import { useEffect, useRef, useState } from "react";

// Remaining seconds for a server-kept session; serverNow (which includes the test clock) sets the skew once per fetch.
export function useCountdown(session, serverNow) {
  const skew = useRef(0);
  const [now, setNow] = useState(Date.now());
  useEffect(() => { if (serverNow) skew.current = new Date(serverNow).getTime() - Date.now(); }, [serverNow]);
  useEffect(() => {
    if (!session) return undefined;
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, [session]);
  if (!session) return 0;
  return Math.max(0, Math.round((new Date(session.end).getTime() - (now + skew.current)) / 1000));
}

export const fmtLeft = (s) => `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}`;

let ac = null;
export function chime(muted) {
  if (muted) return;
  try {
    ac = ac || new (window.AudioContext || window.webkitAudioContext)();
    [523.25, 659.25, 783.99].forEach((f, i) => {
      const o = ac.createOscillator();
      const g = ac.createGain();
      const t = ac.currentTime + i * 0.22;
      o.frequency.value = f;
      g.gain.setValueAtTime(0.0001, t);
      g.gain.exponentialRampToValueAtTime(0.25, t + 0.02);
      g.gain.exponentialRampToValueAtTime(0.0001, t + 0.9);
      o.connect(g).connect(ac.destination);
      o.start(t);
      o.stop(t + 1);
    });
  } catch (_) { /* audio blocked: stay silent */ }
}
